<template>
  <div class="remarks-inside">
    <div class="add-remark" v-if="!!(getFragmentRemarkList.length)">
      <span @click="handleAddRemarks">添加</span>
    </div>
    <div class="remarks-inside-box" v-for="(item , index) in getFragmentRemarkList"
         :key="`${index}-$(item.sentId)`">
      <p class="remarks-content">{{item.comment}}</p>
      <div class="remarks-info">
        <span class="addName" :title="item.name">添加人：{{item.name}}</span>
        <ul class="remarks-info-inside" v-if="getUserInfo===(item.creatorId)">
          <li class="first" @click="()=>handleEditor(item)">编辑</li>
          <li class="last" @click="()=>handleDelete(item)">删除</li>
        </ul>
      </div>
    </div>
    <!--备注的弹出-->
    <Remarks :shown="visible" :remarkInfo="remarkInfos" type="editor"
             @handleCancel="()=>handleCancel()" />
    <Remarks :shown="visible2" :remarkInfo="remarkInfos" type="add"
             @handleCancel="()=>handleCancel()" />
  </div>
</template>

<script>
import Remarks from "@/components/layer/remarks";
import { preventReClick } from '@/services/common'

export default {
  name: "RemarksBox",
  components: { Remarks },
  data () {
    return {
      value: '选项1',
      visible: false,
      visible2: false,
      remarkInfos: {},
    };
  },
  computed: {
    //不使用用辅助函数的获取数据
    getFragmentRemarkList () {
      return (this.$store.getters['editor/getFragmentRemarkInfo']) || {};
    },
    //获取当前用户的信息
    getUserInfo () {
      const userInfo = this.$store.getters['editor/getUserInfo'];
      return (userInfo.id)
    }
  },
  mounted () {
    //  this.getFragmentRemarkList();
  },
  methods: {
    //  getFragmentRemarkList(){
    //    console.log(this.fragmentList)
    //   this.fragmentList=this.$store.getters['editor/getFragmentRemarkInfo'];
    // },
    //编辑批注
    handleEditor (item) {
      this.remarkInfos = {
        id: (item.id),
        sentId: (item.sentId),
        comment: (item.comment),
        sourceSent: (item.commentSent),
        commentType: (item.commentType),
        commentSent: (item.commentSent),
        transFileId: (item.transFileId),
        commentIndex: (item.commentIndex),
      };
      this.visible = true;
    },

    //添加批注
    handleAddRemarks () {
      const remarkListInfo = this.$store.getters['editor/getFragmentRemarkInfo'];
      if (remarkListInfo.length) {
        let firstList = remarkListInfo[0];
        this.remarkInfos = {
          sentId: (firstList.sentId),
          sourceSent: (firstList.commentSent),
          commentSent: (firstList.commentSent),
          commentIndex: (firstList.commentIndex)
        };
        this.visible2 = true;
        console.log(firstList);
        console.log(this.remarkInfos)
      }


    },

    //删除批注
    handleDelete (item) {
      const self = this;
      let fileId = 0;
      let urlInfo = self.$store.getters['editor/getUrlInfo'];
      if ((urlInfo.type) === 'project') {
        let fileInfo = self.$store.getters['editor/getFileInfo'];
        fileId = (fileInfo.id);
      } else if (((urlInfo.type) === 'task') || ((urlInfo.type) === 'school')) {
        let fileTaskInfo = self.$store.getters['editor/getFileTaskInfo'];
        fileId = (fileTaskInfo.fileId);
      }
      let commentIdList = Array.of((`${item.id}`));
      let remarksParams = {
        transFileId: fileId,
      };
      Reflect.set(remarksParams, 'commentIdList', commentIdList);
      Reflect.set(remarksParams, 'item', item);
      this.$store.dispatch('editor/deleteSentRemarksInfo', remarksParams).then((resp) => {
        if (resp) {
          let sentIdList = Array.of((`${item.sentId}`));
          let remarksParams = {
            transFileId: fileId
          };
          Reflect.set(remarksParams, 'sentIdList', sentIdList);
          this.$store.dispatch('editor/getCurrentRemarksInfo', remarksParams)
        }
      })
    },

    //批注的弹层关闭
    handleCancel () {
      this.visible = false;
      this.visible2 = false;
    },
  }
}
</script>

<style lang="less" scoped>
@import "./assets/style.less";
</style>